import React from 'react';

import { useFormContext } from 'react-hook-form';
import colorsVars from 'styles/colors.module.scss';
import { isValidFileSize, isValidFileType } from 'utilitys/helpers/general';

import { MuiIcon } from 'components/common/muiIcon/muiIcon';

import { CustomizedFormErrorMessage } from 'components/common';
import { FormProps } from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/UploadRisksModal';
import classes from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/UploadRisksModal.module.scss';

const { radioButtonDarkerColor } = colorsVars;

export const FileUploadInput = () => {
    const form = useFormContext<FormProps>();

    const handleFileSelection = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (files) {
            form.setValue('file', files[0]);
        }
        return form.trigger('file');
    };

    return (
        <>
            <div className={classes.row}>
                <label htmlFor="upload-excel-file" className={classes.customImageUpload}>
                    <MuiIcon icon={'file_upload'} fontSize={'2.8rem'} color={radioButtonDarkerColor} />
                    <span
                        style={{
                            color: radioButtonDarkerColor,
                        }}
                    >
                        Upload File (.csv)
                    </span>
                </label>
                <input
                    className={classes.fileUploadInput}
                    id="upload-excel-file"
                    type="file"
                    accept="text/csv"
                    {...form.register('file', {
                        validate: {
                            required: (value) => Boolean(value) || 'Must upload risks file',
                            isValidFileType: (value) =>
                                isValidFileType(value, ['text/csv']) || 'Only .csv files are allowed!',
                            isValidFileSize: (value) =>
                                isValidFileSize(value, 5242880) || 'Maximum file size allowed for upload 5mb',
                        },
                    })}
                    onChange={handleFileSelection}
                />
                {form.formState.errors.file ? (
                    <CustomizedFormErrorMessage text={form.formState.errors.file.message} />
                ) : (
                    <div className={classes.imageUploadTitle}>
                        {form.watch('file') && `File: ${form.watch('file')?.name}`}
                    </div>
                )}
            </div>
        </>
    );
};
